import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import SelectCountry from "./SelectCountry";

export default function LanguageDialog(props) {
  const { open, close, lang, setLang, multiLang } = props;

  function handleClose() {
    close();
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <SelectCountry
            setLang={e =>
              setLang({
                lang: e,
                dir: e === "fa" ? "rtl" : "ltr"
              })
            }
            multiLang={multiLang}
            lang={lang}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
